import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ValidationTopErrorMessage from '../portal/controls/validationTopErrorMessage';
import SmtpSettings from './smtpSettings';
import DomainManagerSettings from './domainManager';
import ToastrLevelsEnum from '../../services/enums/toastrLevelsEnum';
import ToastrService from '../../services/ui/toastrService';
import GeneralSettingsTabs from './generalSettingsTabs';
import UserInactivityCleanup from './userInactivityCleanup';

@inject('translationsStore', 'smtpSettingsStore', 'oidcStore', 'configurationsStore', 'routesStore') @observer
export default class GeneralSettingsForm extends Component {

    setSelectedTabId = tab => {
        this.props.routesStore.setSelectedSecurityTab(tab.props.value);
    }

    handleActive = tab => {
        if (this.props.routesStore.generalSettingsSelectedTab !== tab.props.value) {
            this.props.routesStore.setSelectedGeneralSettingsTab(tab.props.value);
        }
    }

    componentDidMount() {
        var { isDefaultTenant } = this.props.configurationsStore;
        this.props.configurationsStore.updateStore();
        this.props.routesStore.setSelectedGeneralSettingsTab(isDefaultTenant ? 1 : 3); 
    }

    handleSubmitForm = (e) => {

        e.preventDefault();

        this.props.smtpSettingsStore.setSaveSmtpSettingsErrorMessage('');

        const isValid = this.props.smtpSettingsStore.validateSmtpSettingsForm();

        if (isValid === false) {

            const validationErrorMessage = this.props.translationsStore.translate('SEE_ERRORS_BELOW');
            this.props.smtpSettingsStore.setSaveSmtpSettingsErrorMessage(validationErrorMessage);
            return;
        }

        this.props.smtpSettingsStore.SaveSmtpSettings().then(() => {
            var level = ToastrLevelsEnum.SUCCESS;
            var message = this.props.translationsStore.translate('SMTP_SETTINGS_UPDATE_SUCCESS_MESSAGE');
            ToastrService.triggerToastr({ level, message });
        });
    };

    buildSmtpSettingsRegionIfNeeded() {
        var { isMultitenancyMode, isDefaultTenant } = this.props.configurationsStore;
        return isMultitenancyMode === false || isDefaultTenant ? <SmtpSettings /> : null;
    }

    buildDomainManagementSettingsRegionIfNeeded() {
        var { isMultitenancyMode } = this.props.configurationsStore;
        return (isMultitenancyMode === false) ? <DomainManagerSettings /> : null;
    }

    render() {
        var smtpComponent = this.buildSmtpSettingsRegionIfNeeded();
        var domainManagementComponent = this.buildDomainManagementSettingsRegionIfNeeded();

        const tabs = [];

        const { isMultitenancyMode, isDefaultTenant } = this.props.configurationsStore;

        if (smtpComponent && (isMultitenancyMode === false || isDefaultTenant)) tabs.push({
            id: 1,
            title: this.props.translationsStore.translate('SMTP_SETTINGS_TITLE'),
            dataCy: 'smtp-settings-tab',
            component: smtpComponent
        });
        if (domainManagementComponent) tabs.push({
            id: 2,
            title: this.props.translationsStore.translate('DOMAIN_MANAGMENT'),
            dataCy: 'domain-management-tab',
            component: domainManagementComponent
        });
        tabs.push({
            id: 3,
            title: 'Inactivity Cleanup',
            dataCy: 'inactivity-cleanup-tab',
            component: <UserInactivityCleanup />
        });

        return (
            <form onSubmit={this.handleSubmitForm}>
                <div>
                    <ValidationTopErrorMessage errorMessage={this.props.smtpSettingsStore.saveSmtpSettingsErrorMessage} />
                    <GeneralSettingsTabs
                        tabs={tabs}
                        handleActive={this.handleActive}
                        selectedTabId={this.props.routesStore.generalSettingsSelectedTab}
                    />
                </div>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/generalSettings/generalSettingsForm.jsx